import { useState } from "react";
import ConfirmDialog from "./ConfirmDialog";
import SafeConfirmDialog from "./SafeConfirmDialog";

const useConfirmDialog = () => {
  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState("");

  return {
    display: (data) => {
      setOpen(true);
      setDescription(data);
    },
    renderDialog: (confirmationHandler) => {
      return (
        <ConfirmDialog
          isOpen={open}
          setIsOpen={setOpen}
          description={description}
          confirmationHandler={confirmationHandler}
        />
      );
    },
    renderSafeDialog: (confirmationHandler) => {
      return (
        <SafeConfirmDialog
          isOpen={open}
          setIsOpen={setOpen}
          description={description}
          confirmationHandler={confirmationHandler}
        />
      );
    },
  };
};

export default useConfirmDialog;
